export const PAGE_FIX_ACCESSIBILITY_CHECK_DIFFICULTY = {
    EASY: 'easy',
    MEDIUM: 'medium',
    HARD: 'hard',
} as const;
